import React from "react";

// Gold ribbon carrying the offer's badge text. Always has text, so the offer is
// never signalled by colour alone.
const OfferBadge = ({ theme, text, className = "" }) => {
  if (!text) return null;

  return (
    <span
      className={`inline-flex max-w-full items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-black uppercase tracking-wide shadow-sm ${className}`}
      style={{ background: theme.badgeBackground, color: theme.onAccent }}
    >
      {theme.iconUrl ? (
        <img src={theme.iconUrl} alt="" className="h-3.5 w-3.5 shrink-0 object-contain" />
      ) : (
        <span aria-hidden="true" className="shrink-0">{theme.icon}</span>
      )}
      <span className="truncate">{text}</span>
    </span>
  );
};

export default OfferBadge;
